// a11y: when prefers-reduced-motion is set, autoplay videos show their
// poster image instead of playing.
//
// Loaded synchronously (no defer) from <head> in layout/theme.liquid so
// the interceptors are in place before any <video> element is parsed
// or cloned into the live DOM.

(function () {
  if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  // Capture-phase 'play' listener: fires for any video that tries to play,
  // including videos that JS calls .play() on synchronously after cloning
  // from a <template> (the MutationObserver runs as a microtask and is too
  // late to prevent that initial play). Capture fires before any descendant
  // 'play' handlers.
  //
  // Strict pause: any video that was autoplay always pauses. No user-intent
  // escape hatch - reduce-motion users shouldn't have to learn hidden
  // affordances to predict whether a click triggers playback. The narrow
  // trade-off: <video autoplay controls> renderings (rare in this theme:
  // only blocks/video.liquid) can't be played via their controls button.
  // Acceptable for strict reduce-motion adherence.
  document.addEventListener(
    'play',
    function (e) {
      var v = e.target;
      if (!(v instanceof HTMLVideoElement)) return;
      if (v.hasAttribute('autoplay') || v.dataset.wasAutoplay) {
        v.dataset.wasAutoplay = 'true';
        v.pause();
      }
    },
    true
  );

  function neutralize(v) {
    if (!(v instanceof HTMLVideoElement)) return;
    if (v.hasAttribute('autoplay')) {
      v.dataset.wasAutoplay = 'true';
      v.removeAttribute('autoplay');
      v.autoplay = false;
    }
    if (!v.paused) v.pause();
    // Intentionally don't touch v.preload or v.currentTime here.
    // We run as a microtask, AFTER theme.js sets preload="metadata" and
    // calls play() synchronously. Mutating preload at that point can leave
    // the video in an inconsistent state where the poster intermittently
    // fails to render. Trust the capture-phase 'play' listener above to
    // pause any subsequent play attempts.
  }

  // Protects a .video-thumbnail element from being removed by
  // VideoLocal.loadContentVideo() in theme.js. The thumbnail IS the section's
  // poster image for most video-local sections (video-with-text-overlay,
  // media-hero, etc.) - removing it disrupts the inner <img is="lazy-loading-img">
  // because LazyLoadingImg.disconnectedCallback() clears its cached parent
  // and there's no connectedCallback to re-initialize. The lazy-loader's
  // src/srcset promotion then never runs and the user sees the 10px
  // blur-up placeholder stretched to full size.
  // Overriding remove() at the instance level lets us keep the element in
  // DOM without touching the prototype or the theme code.
  function protectThumbnail(el) {
    if (!el || !el.classList || !el.classList.contains('video-thumbnail')) return;
    if (el.dataset.reducedMotionProtected) return;
    el.dataset.reducedMotionProtected = 'true';
    el.remove = function () {};
  }

  // Initial sweep for any videos / thumbnails that exist at script-execution time.
  document.querySelectorAll('video[autoplay]').forEach(neutralize);
  document.querySelectorAll('.video-thumbnail').forEach(protectThumbnail);

  // Catch elements added during page parse and cloned in later by
  // lazy-loading / carousel components.
  new MutationObserver(function (muts) {
    muts.forEach(function (m) {
      m.addedNodes.forEach(function (n) {
        if (n.nodeType !== 1) return;
        if (n.tagName === 'VIDEO') {
          neutralize(n);
        } else if (n.classList && n.classList.contains('video-thumbnail')) {
          protectThumbnail(n);
        }
        if (n.querySelectorAll) {
          n.querySelectorAll('video[autoplay]').forEach(neutralize);
          n.querySelectorAll('.video-thumbnail').forEach(protectThumbnail);
        }
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
